import React, { PureComponent } from 'react';
import { filterReduxFormInput } from '../../core/util/form';
import { analyticsTrackEvent } from '../../core/analytics';
import { isEmptyObject } from '../../core/util/object';
import { isEmpty } from '../../core/util/empty';

export const displayErrors = (field: any, showErrors: any, touched: any, submitted: any) =>
  (submitted || touched) && field.error && showErrors;

type OwnProps = {
  s: any;
  id: string;
  label?: string;
  field: any;
  values: any[];
  style?: React.CSSProperties;
  trackEvent?: string;
  hasDefault?: boolean;
  defaultValue?: string;
  onExternalCall?: (...args: any[]) => any;
  showErrors?: boolean;
  sensitive?: boolean;
  onBlur?: (...args: any[]) => any;
  onFocus?: (...args: any[]) => any;
  errorInline?: boolean;
  funPlaceholder?: boolean;
  placeholder?: string;
  onChangeIsNestedObject?: boolean;
  submitted?: boolean;
  validateField?: (...args: any[]) => any;
  inputProps?: any;
};

type State = any;

type Props = OwnProps & typeof SelectInput.defaultProps;

class SelectInput extends PureComponent<Props, State> {
  static defaultProps = {
    showErrors: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      touched: false,
    };
  }

  getClassName = () => {
    switch (typeof this.props.field.value) {
      case 'undefined':
        return this.props.s.emptyValue;
      case 'string':
        return this.props.field.value === '' ? this.props.s.emptyValue : '';
      case 'number':
        return Number.isNaN(this.props.field.value) ? this.props.s.emptyValue : '';

      default:
        return '';
    }
  };

  handleChange = (e: any) => {
    this.setState({ touched: true });
    const properties = { name: this.props.id };
    analyticsTrackEvent(this.props.trackEvent, properties);
    const value = this.props.onChangeIsNestedObject ? e.target.value : e;
    this.props.field.onChange(value);
    this.props.validateField && this.props.validateField();
  };

  render() {
    const { touched } = this.state;
    const { submitted, field, errorInline, onBlur, onFocus } = this.props;
    const inputValues = !isEmptyObject(this.props.inputProps)
      ? this.props.inputProps
      : filterReduxFormInput(this.props.field);

    return (
      <div
        {...(this.props.style && { style: this.props.style })}
        className={
          displayErrors(field, errorInline, touched, submitted)
            ? this.props.s.formFieldInlineError
            : this.props.s.formField
        }
      >
        {this.props.label && <label htmlFor={this.props.id}>{this.props.label}</label>}

        <div className={this.props.s.formInputContainer}>
          <div className={this.getClassName()}>
            <select
              {...inputValues}
              className={this.props.sensitive ? 'inspectletIgnore' : ''}
              id={this.props.id}
              onBlur={onBlur}
              onChange={this.handleChange}
              onFocus={onFocus}
            >
              {isEmptyObject(this.props.hasDefault) && !this.props.hasDefault && (
                <option key="" value="">
                  {this.props.defaultValue || 'Select'}
                </option>
              )}
              {this.props.values.map((value) => (
                <option key={value.key} value={value.key}>
                  {value.label}
                </option>
              ))}
            </select>
          </div>
          {this.props.funPlaceholder && !isEmpty(this.props.field.value) && (
            <div className={this.props.s.stickyPlaceholder}>{this.props.placeholder}</div>
          )}
        </div>
        {this.props.showErrors &&
          (this.props.submitted || this.state.touched || this.props.field.touched) &&
          this.props.field.error && (
            <div className={this.props.s.formFieldError}>{this.props.field.error}</div>
          )}
      </div>
    );
  }
}

export default SelectInput;
